import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type ApplicationItem = {
    id: number,
    volume: number,
    value: string,
    type: any  
}

type ApplicationItemDto = {
    volume: number,
    value: string,
    type: any  
}

export const applicationItemsApi = createApi({
    reducerPath: 'applicationItemsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["APPLICATION-ITEMS"],
    endpoints: builder => ({
        getAllApplicationItems: builder.query<ApplicationItem[], void>({
            query: () => ({ url: `/application-items` }),
            providesTags: ["APPLICATION-ITEMS"]
        }),
        getApplicationItem: builder.query<ApplicationItem, { id: number }>({
            query: ({ id }) => ({ url: `/application-items/${id}` }),
            providesTags: ["APPLICATION-ITEMS"]
        }),
        createApplicationItem: builder.mutation<any, ApplicationItemDto>({
            query: (body) =>({url: `/application-items`, method: "POST", body: body}),
            invalidatesTags: ["APPLICATION-ITEMS"]
        })
    })
})

export const { useGetAllApplicationItemsQuery, useGetApplicationItemQuery, useCreateApplicationItemMutation } = applicationItemsApi
